<p>help-shopify-identity-select works!</p>
